import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NeproseService {

  constructor( private _http: HttpClient, private _router: Router){}

  getUserProfile(){
    return this._http.get<any>(environment.api+'/api/users/user-info')
  }

  updateProfileImage(image){
    let formData = new FormData()
    formData.append('image', image)
    return this._http.put<any>(environment.api+'/api/users/change-profile', formData)
  }

  updateUser(user){
    let params = new HttpParams({
      fromObject: user
    })
    return this._http.put<any>(environment.api+'/api/users/update', params)
  }

  addAdvertisement(ad: FormData){
    return this._http.post<any>(environment.api+'/api/property-item/add', ad)
  }

  getProvinceList(){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/provinces/getall', httpOptions)
  }

  getDistrictList(){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/districts/getall', httpOptions)
  }

  getMunicipalityList(){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/municipalities/getall', httpOptions)
  }

  getAdvertisement(id){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/property-item/getone/'+id, httpOptions)
  }

  propertyViewed(id, ipAddress){
    let params = new HttpParams({
      fromObject: {
        ip: ipAddress
      }
    })
    return this._http.post<any>(environment.api+'/api/propertyips/add/'+id, params)
  }

  getSeller(id){
    return this._http.get<any>(environment.api+'/api/users/getone/'+id)
  }

  getProperties(page, filterTitle, filterValue){
    let url = environment.api+'/api/property-item/getall?offset='+page
    if(filterTitle && filterValue){
      url = url +'&'+filterTitle+'='+filterValue
    }
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(url, httpOptions)
  }

  searchProperty(price, date, keywordTitle, keyword: any, type: any, listingFor: any){
    let url = environment.api+'/api/property-item/search?'+keywordTitle+'='+keyword
    if(type){
      url = url +'&type'+'='+type
    }
    if(price){
      url=url+'&price='+price
    }
    if(date){
      url=url+'&date='+date
    }
    if(listingFor){
      url=url+'&listingFor='+listingFor
    }
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(url, httpOptions)
  }

  getAdPlans(){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/itemPlans/getall', httpOptions)
  }

  getPropertyTypes(){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>(environment.api+'/api/property-types/getall', httpOptions)
  }

  getIPAddress(){  
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true'})
    };
    return this._http.get<any>("https://api.ipify.org/?format=json", httpOptions);  
  }  

  getMyProperties(){
    return this._http.get<any>(environment.api+'/api/property-item/foruser');  
  }

  getMyFavourites(){
    return this._http.get<any>(environment.api+'/api/favorites/get-for-user');  
  }

  addToFavourite(id){
    return this._http.get<any>(environment.api+'/api/favorites/add/'+id);
  }

  deleteFromFavourite(id){
    return this._http.delete<any>(environment.api+'/api/favorites/delete/'+id);
  }

  verifyUserPhone(code){
    let params = new HttpParams({
      fromObject: {
        code: code
      }
    })
    return this._http.post<any>(environment.api+'/api/verifyphone/checkcode', params)
  }

  updateProperty(id, property){
    let params = new HttpParams({
      fromObject: property
    })
    return this._http.put<any>(environment.api+'/api/property-item/update/'+id, params)
  }


  updatePropertyStatusToSold(id){
    let params = new HttpParams({})
    return this._http.put<any>(environment.api+'/api/property-item/status/tosold/'+ id, params)
  }

  updatePropertyStatusToCompleted(id){
    let params = new HttpParams({})
    return this._http.put<any>(environment.api+'/api/property-item/status/tocompleted/'+ id, params)
  }

  changePropertyImage(id, images){
    let formData = new FormData()
    for(let image of images){
      formData.append('images', image)
    }
    return this._http.put<any>(environment.api+'/api/property-item/addimage/'+id, formData)
  }

  deletePropertyImage(id, image){
    return this._http.delete<any>(environment.api+'/api/property-item/deleteimage/'+id+'/'+image)
  }

  getBlogs(offset, date){
    return this._http.get<any>(environment.api+'/api/blogs/filter?offset='+offset+'&date='+date)
  }

  getBlog(slug){
    return this._http.get<any>(environment.api+'/api/blogs/getslug/'+slug)
  }

  getTrendingProperties(){
    return this._http.get<any>(environment.api+'/api/property-item/getpopular')
  }

  addBankPayment(voucher){
    let formData = new FormData()
    for(let key in voucher){
      formData.append(key, voucher[key])
    }
    return this._http.post<any>(environment.api+'/api/bankpayments/add', formData)
  }

  updateBankPayment(id, voucher){
    let formData = new FormData()
    for(let key in voucher){
      formData.append(key, voucher[key])
    }
    return this._http.put<any>(environment.api+'/api/bankpayments/update/'+id, formData)
  }

  getBankPayment(aliasId){
    return this._http.get<any>(environment.api+'/api/bankpayments/getbyaliasid/'+aliasId)
  }

  deleteBankPayment(id){
    return this._http.delete<any>(environment.api+'/api/bankpayments/delete/'+id)
  }

  getTransaction(aliasId){
    return this._http.get<any>(environment.api+'/api/transactions/getbyaliasid/'+aliasId)
  }

  deleteTransaction(id){
    return this._http.delete<any>(environment.api+'/api/transactions/delete/'+id)
  }

  getRoadBlock(){
    return this._http.get<any>(environment.api+'/api/roaditems/getselected')
  }

  checkAdmin(token){
    const httpOptions = {
      headers: new HttpHeaders({'X-Skip-Interceptor':  'true', 'Authorization': 'Bearer '+token})
    };
    return this._http.get<any>(environment.api+'/api/roaditems/getall', httpOptions)
  }

  getLocalAds(page){
    return this._http.get<any>(environment.api+'/api/localitems/getforpage/'+page)
  }

  getBannerImage(page){
    let url = environment.api+'/api/homebanners/getselected/'+page
    return this._http.get<any>(url)
  }

  addSubscription(email){
    let params = new HttpParams({
      fromObject: {
        email: email
      }
    })
    return this._http.post<any>(environment.api +'/api/subscriptions/add', params)
  }

  contact(form){
    let params = new HttpParams({
      fromObject: form
    })
    return this._http.post<any>(environment.api +'/api/contacts', form)
  }

}
